import { AxiosError } from 'axios';
import { KeyValueResponse } from '../../api';

import { GET_NON_NATIONAL_EXAM_GROUPS_URL } from '../../constants/apiUrls';
import { GET_NON_NATIONAL_EXAM_GROUPS_QUERY_KEY } from '../../constants/queryKeys';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import {GenericErrorResponse} from "../typings";

interface Input {
  onSuccess?: (data: KeyValueResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export const useGetNonNationalExamGroups = ({ onSuccess, onError }: Input = {}) => {
  const getNonNationalExamGroups = async () => {
    const res = await axiosClient.get<KeyValueResponse[]>(GET_NON_NATIONAL_EXAM_GROUPS_URL);
    return res.data;
  };

  return useCustomQuery([GET_NON_NATIONAL_EXAM_GROUPS_QUERY_KEY], getNonNationalExamGroups, {
    onSuccess,
    onError,
  });
};
